import css from 'styled-jsx/css';
import { colorPalette } from 'styles/css-constants';
import { MQ_LARGE, MQ_MEDIUM } from 'constants/mq';

/*
Overview
--------
*/
export default css`
  .Spread__item {
    margin-bottom: 1.5rem;
  }

  .Spread__item--TeaserRecipeCard:empty {
    display: none;
  }

  .Spread__item--profile:last-child,
  .Spread__item--teaser:last-child,
  .Spread__item--teaserCard:last-child,
  .Spread__item--TeaserRecipeCard:last-child {
    margin-bottom: 0;
  }

  .Spread__items {
    grid-template-columns: repeat(auto-fill, minmax(163.5px, 1fr));
    grid-column-gap: 1rem;
  }

  .Spread__title {
    margin: 0 1rem;
    border-top: 2px solid ${colorPalette.gray};
    border-bottom: none;
    padding: 1rem 0;
  }

  .Spread__title h4 {
    color: $gray--darker;
    font-size: var(--fontScaleNeg1);
    font-weight: normal;
    text-align: center;

    font-size: 18px;
  }

  @media (min-width: 48rem) {
    .Spread__item--ad {
      flex: 0 0 100%;
      max-width: 100%;
    }

    .Spread__item--profile,
    .Spread__item--teaser {
      flex: 0 0 33.33%;
      margin-bottom: 1.5rem;
      max-width: 33.33%;
      padding: 0 0.75rem;
    }

    .Spread__items {
      padding: 0;
    }

    .Spread__title {
      margin: 0;
    }
  }

  @media screen and ${MQ_MEDIUM} {
    .Spread__items {
      grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
      grid-column-gap: 1.25rem;
    }
  }

  @media screen and ${MQ_LARGE} {
    .Spread--flexibleGrid {
      grid-template:
        'title'
        'description'
        'items' /
        1fr;
    }

    .Spread__items {
      grid-template-columns: repeat(auto-fill, minmax(244px, 1fr));
    }

    .Spread__title h4 {
      font-size: var(--fontScale1);
    }
  }
`;
